<template>
	<div class="filters-box">
		<div class="filters-box-row">
			<div class="data-picker-box">
				<span>时间周期：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					type="daterange"
					:clearable='false'
					align="right"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="order-group-box">
				<span>客户名称：</span>
				<el-input v-model="cusname" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			dateValue: [],
			cusname: ''
		}
	},
	created () {
		this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
	},
	methods: {
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		clearSearch () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
			this.cusname = ''
		},
		getFiltersParams () {
			let filtersParams = []
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'endDate', data: `${this.$fxUtils.getCurrentMonthLast()} 23:59:59`, 'op': 'le' },
					{ field: 'beginDate', data: `${this.$fxUtils.getCurrentMonthFirst()} 00:00:00`, 'op': 'ge' }
				]
			} else {
				filtersParams = [
					{ field: 'endDate', data: `${this.dateValue[1]} 23:59:59`, 'op': 'le' },
					{ field: 'beginDate', data: `${this.dateValue[0]} 00:00:00`, 'op': 'ge' }
				]
			}
			if (this.cusname) {
				let cusnameObj = { 'field': 'cusname', 'data': this.cusname, 'op': 'cn' }
				filtersParams.push(cusnameObj)
			}
			return {
				filtersParams
			}
		},
		getFiltersDate () {
			return [
				{ field: 'endDate', data: `${this.dateValue[1]} 23:59:59`, 'op': 'le' },
				{ field: 'beginDate', data: `${this.dateValue[0]} 00:00:00`, 'op': 'ge' }
			]
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	.filters-box-row {
		display:flex
		margin-bottom: 10px
		&:last-child {
			margin-bottom: 0px
		}
		.data-picker-box {
			margin-right:10px
		}
		.order-type-box {
			margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-group-box, .order-shop-box {
			.order-input {
				width:150px
			}
		}
		.order-group-box {
			margin-right:10px
		}
	}
}
</style>
